var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJpSalary({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "outline/cash"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 6.75C2 5.23122 3.23122 4 4.75 4H14.75C16.2688 4 17.5 5.23122 17.5 6.75V8H18.75C20.2688 8 21.5 9.23122 21.5 10.75V16.75C21.5 18.2688 20.2688 19.5 18.75 19.5H8.75C7.23122 19.5 6 18.2688 6 16.75V15.5H4.75C3.23122 15.5 2 14.2688 2 12.75V6.75ZM7.5 16.75C7.5 17.4404 8.05964 18 8.75 18H18.75C19.4404 18 20 17.4404 20 16.75V10.75C20 10.0596 19.4404 9.5 18.75 9.5H8.75C8.05964 9.5 7.5 10.0596 7.5 10.75V16.75ZM16 8H8.75C7.23122 8 6 9.23122 6 10.75V14H4.75C4.05964 14 3.5 13.4404 3.5 12.75V6.75C3.5 6.05964 4.05964 5.5 4.75 5.5H14.75C15.4404 5.5 16 6.05964 16 6.75V8ZM13.75 12.5C13.0596 12.5 12.5 13.0596 12.5 13.75C12.5 14.4404 13.0596 15 13.75 15C14.4404 15 15 14.4404 15 13.75C15 13.0596 14.4404 12.5 13.75 12.5ZM11 13.75C11 12.2312 12.2312 11 13.75 11C15.2688 11 16.5 12.2312 16.5 13.75C16.5 15.2688 15.2688 16.5 13.75 16.5C12.2312 16.5 11 15.2688 11 13.75Z",
    fill: "#70758F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJpSalary);
export default __webpack_public_path__ + "static/media/jp-salary.50e7007e435c9843bf545cb1a2a81f22.svg";
export { ForwardRef as ReactComponent };